/**
 * Not Financial Advice Disclaimer - Phase 16: Security & Compliance
 *
 * Persistent footer disclaimer displayed on all pages.
 */
import './Disclaimer.css'

export function Disclaimer() {
  return (
    <div className="disclaimer-bar">
      <p>
        Cipher provides data and analysis tools for informational purposes only.
        Nothing on this platform constitutes financial advice.
        Always consult a qualified financial advisor before making investment decisions.
      </p>
    </div>
  )
}

export function AIDisclaimer() {
  return (
    <span className="ai-disclaimer">
      This is not financial advice.
    </span>
  )
}

export function ScoreDisclaimer() {
  return (
    <span className="score-disclaimer" title="For informational purposes only. Not financial advice.">
      *
    </span>
  )
}

export function BacktestDisclaimer() {
  return (
    <div className="backtest-disclaimer">
      Past performance does not guarantee future results.
    </div>
  )
}

export default Disclaimer
